export const whoThisIsForData = {
  title: 'Who This Is For',
  items: [
    {
      title: (
        <>
          <b>Product Teams</b> with unique synthetic data needs that platforms
          can't address
        </>
      ),
    },
    {
      title: (
        <>
          <b>Gaming & Entertainment</b> companies needing procedural content
          generation
        </>
      ),
    },
    {
      title: (
        <>
          <b>AI/ML Teams</b> requiring custom training datasets with specific
          characteristics
        </>
      ),
    },
    {
      title: (
        <>
          <b>Startups & Scale-ups</b> building innovative products with novel
          data requirements
        </>
      ),
    },
    {
      title: (
        <>
          <b>Companies</b> frustrated with the limitations of off-the-shelf
          synthetic data tools
        </>
      ),
    },
  ],
};
